import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useSpaceImageFallbackStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    ...shorthands.borderRadius('inherit'),
    ...shorthands.overflow('hidden'),
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    background: `radial-gradient(circle at center, ${tokens.colorNeutralBackground1} 0%, ${tokens.colorNeutralBackground6} 100%)`,
  },
  icon: {
    fontSize: fontScale.heading,
    color: tokens.colorNeutralForeground3,
  },
});
